import React from 'react'
import {useIntl} from 'react-intl'
import {useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {FilterDisplayContainer} from 'components/FilterDisplayContainer/FilterDisplayContainer'
import {filterMessages} from 'components/Filters/filterMessages'
import {PriceFilter} from 'components/Filters/PriceFilter/PriceFilter'
import {getPriceActiveLabel} from 'components/Filters/utils'
import {useFiltersForm} from 'hooks/useFiltersForm'
import {usePriceFilter} from 'hooks/usePriceFilter'
import {getCurrencyCode} from 'modules/meta/selectors'
import {searchParamToFacet} from 'modules/search/constants'
import {prop} from 'ramda'

import {getEnabledCurrencies} from '@vio/core/src/localization/business/currency'

const filterKeys = [
  searchParamToFacet.priceMin.param,
  searchParamToFacet.priceMax.param
]

const PriceFilterWrapper = styled.div`
  max-width: 360px;
`

const ActiveLabel = styled.span`
  text-transform: none;
`

interface Props {
  isActive?: boolean
}

export const PriceFilterPopover: React.FC<Props> = ({isActive = false}) => {
  const {formatMessage} = useIntl()
  const {
    submitFilters,
    getFilters,
    getAppliedFilters,
    toggleFilters,
    clearFilters,
    resetFilters,
    trackFilterClick
  } = useFiltersForm(filterKeys, 'price')

  const {
    title: priceFilterTitle,
    subtitle: priceFilterSubtitle,
    getTotalPriceFilter
  } = usePriceFilter()

  const currencyCode = useSelector(getCurrencyCode)
  const enabledCurrencies = getEnabledCurrencies(
    process.env.NEXT_PUBLIC_ENABLED_CURRENCIES
  )
  const currency = enabledCurrencies.find(
    currency => currency.code === currencyCode
  )
  const currencySymbol = prop('symbol', currency)

  const {priceMin, priceMax} = getFilters()
  const appliedFilters = getAppliedFilters()

  const appliedPriceMin = getTotalPriceFilter(appliedFilters.priceMin)
  const appliedPriceMax = getTotalPriceFilter(appliedFilters.priceMax)

  return (
    <FilterDisplayContainer
      label={
        isActive ? (
          <ActiveLabel>
            {getPriceActiveLabel({
              minPrice: appliedPriceMin,
              maxPrice: appliedPriceMax,
              currencySymbol,
              formatMessage
            })}
          </ActiveLabel>
        ) : (
          formatMessage(filterMessages.priceFilter)
        )
      }
      dataId="priceFilter"
      title={formatMessage(priceFilterTitle)}
      subtitle={formatMessage(priceFilterSubtitle)}
      isActive={isActive}
      onClear={clearFilters}
      onApply={submitFilters}
      onClose={resetFilters}
      onPillClick={trackFilterClick}
    >
      <PriceFilterWrapper>
        <PriceFilter
          priceMin={priceMin}
          priceMax={priceMax}
          onChange={toggleFilters}
        />
      </PriceFilterWrapper>
    </FilterDisplayContainer>
  )
}
